import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import * as React from 'react';

interface Props {
  show: boolean;
  children: React.ReactNode;
  anchorEl: HTMLElement;
  handleClickAway: () => void;
  placement?: PopperPlacementType;
}

const InfoPopup = (props: Props) => {
  return (
    <Popper
      style={{ zIndex: 1 }}
      open={props.show}
      anchorEl={props.anchorEl}
      placement={props.placement || 'left-start'}
    >
      <ClickAwayListener onClickAway={props.handleClickAway}>
        <Paper elevation={2}>{props.children}</Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default InfoPopup;
